export const HOME_ROUTE= "/";
export const PRODUCT_DETAIL_ROUTE= "/product-detail";
export const ABOUT_ROUTE= "/about";
